export default function (col) {
  return typeof col.visible === 'undefined' || '' + col.visible === 'true'
}



// WEBPACK FOOTER //
// ./src/_utilities/vue2-datatable/_utils/isColVisible.js